import {Button} from "primereact/button";
import {Link} from "react-router-dom";

export const projectTitle = item => {
	return (
		<>
			<div className="d-grid my-1 text-truncate ">
				<div className="fw-bold d-flex align-items-center text-truncate">
					{item?.full_name_am && (
						<div className="">
							{item?.full_name_am.substring(0, 50)} {item?.full_name_am?.length > 50 ? "..." : null}
						</div>
					)}
				</div>
				<div className="opacity-75 small d-flex align-items-center text-truncate">
					{item?.full_name_en ? (
						item?.full_name_en.substring(0, 100)
					) : (
						<span className="fst-italic text-danger">not provided</span>
					)}
				</div>
			</div>
		</>
	);
};

export const projectStatus = item => {
	return (
		<div className="d-grid my-1 text-truncate ">
			<span className="d-flex align-items-center">
				{item?.completed ? (
					<Button icon="pi pi-check-square" rounded disabled severity="success" />
				) : (
					<Button icon="pi pi-wave-pulse" rounded disabled severity="primary" />
				)}
			</span>
		</div>
	);
};

export const projectID = item => {
	return (
		<div className="d-grid my-1 text-truncate ">
			<div className="fw-bold d-flex align-items-center">{item?.number}</div>
			<div className="opacity-75 small mt-1 d-flex align-items-center">{item?.name}</div>
		</div>
	);
};

export const projectDates = item => {
	if (!item?.start_date || !item?.end_date) return null;

	const formatDate = dateString => {
		const date = new Date(dateString);
		return new Intl.DateTimeFormat("ru-RU").format(date); // "01.10.2024"
	};

	return (
		<div className="d-grid my-1 text-truncate">
			{formatDate(item.start_date)} - {formatDate(item.end_date)}
		</div>
	);
};

export const projectAction = item => {
	return (
		item?.end_date && (
			<div>
				<Link to={`${"/project/" + item.id}`} className="opacity-50">
					<Button icon="pi pi-arrow-right" rounded severity="secondary" />
				</Link>
			</div>
		)
	);
};
